import { Line } from 'vue-chartjs';

export default {
   extends: Line,
   props: ['datacollection', 'options'],
   data() {
      return {
        
         //Chart.js options that controls the appearance of the chart

      }
   },
   mounted() {
      //renderChart function renders the chart with the datacollection and options object.
      this.renderChart(this.datacollection, this.options)
   }
}


// WEBPACK FOOTER //
// ./src/components/chart/LineExample.js